export const UNIT_OF = {
    CAPACITY: 'capacity',
    IOPS: 'iops',
    THROUGHPUT: 'throughput'
};

export const DECIMAL_SIZE_UNITS = {
    B: { unit: { [UNIT_OF.CAPACITY]: 'B', [UNIT_OF.IOPS]: '', [UNIT_OF.THROUGHPUT]: 'B/s'}, size: 1 },
    KB: { unit: { [UNIT_OF.CAPACITY]: 'KB', [UNIT_OF.IOPS]: 'K', [UNIT_OF.THROUGHPUT]: 'KB/s' }, size: 1000 },
    MB: { unit: { [UNIT_OF.CAPACITY]: 'MB', [UNIT_OF.IOPS]: 'M', [UNIT_OF.THROUGHPUT]: 'MB/s' }, size: 1000000 },
    GB: { unit: { [UNIT_OF.CAPACITY]: 'GB', [UNIT_OF.IOPS]: 'G', [UNIT_OF.THROUGHPUT]: 'GB/s' }, size: 1000000000 },
    TB: { unit: { [UNIT_OF.CAPACITY]: 'TB', [UNIT_OF.IOPS]: 'T', [UNIT_OF.THROUGHPUT]: 'TB/s' }, size: 1000000000000 },
    PB: { unit: { [UNIT_OF.CAPACITY]: 'PB', [UNIT_OF.IOPS]: 'P', [UNIT_OF.THROUGHPUT]: 'PB/s' }, size: 1000000000000000 },
    EB: { unit: { [UNIT_OF.CAPACITY]: 'EB', [UNIT_OF.IOPS]: 'E', [UNIT_OF.THROUGHPUT]: 'EB/s' }, size: 1000000000000000000 },
    ZB: { unit: { [UNIT_OF.CAPACITY]: 'ZB', [UNIT_OF.IOPS]: 'Z', [UNIT_OF.THROUGHPUT]: 'ZB/s' }, size: 1000000000000000000000 },
    YB: { unit: { [UNIT_OF.CAPACITY]: 'YB', [UNIT_OF.IOPS]: 'Y', [UNIT_OF.THROUGHPUT]: 'YB/s' }, size: 1000000000000000000000000 }
};

const SIZE_UNITS_ARR = [DECIMAL_SIZE_UNITS.B, DECIMAL_SIZE_UNITS.KB, DECIMAL_SIZE_UNITS.MB, DECIMAL_SIZE_UNITS.GB, DECIMAL_SIZE_UNITS.TB,
DECIMAL_SIZE_UNITS.PB, DECIMAL_SIZE_UNITS.EB, DECIMAL_SIZE_UNITS.ZB, DECIMAL_SIZE_UNITS.YB];

function getSizeWithUnit(value, unitType, unit, showDecimal = false, showUnit = true) {
    const valueInUnit = value / unit.size;
    const unitString = showUnit ? `${unitType === UNIT_OF.IOPS ? '' : ' '}${unit.unit[unitType]}` : '';
    if (showDecimal || valueInUnit < 0.5) {
        const value = Number(valueInUnit.toFixed(2)).toLocaleString();
        return `${value}${unitString}`;
    }
    else {
        const value = Math.round(valueInUnit).toLocaleString();
        return `${value}${unitString}`;
    }
}

/**
 * Returns the formatted size as string with minimum unit.
 * If the value is less than the minimum unit, it will return the value with the minimum unit.
 * If the value is greater than or equal to the minimum unit, it will return the value
 * with minimum or a larger unit 
 */
export function formatSize(value, unitType = UNIT_OF.IOPS, minOutputUnit = DECIMAL_SIZE_UNITS.KB, showDecimal = false, showUnit = true) {
    if (typeof value !== 'number' || isNaN(value) || value < 0) {
        return '';
    }
    if (value < minOutputUnit.size) {
        return getSizeWithUnit(value, unitType, minOutputUnit, showDecimal, showUnit);
    }
    else {
        for (let i = SIZE_UNITS_ARR.length - 1; i >= 0; i--) {
            const unit = SIZE_UNITS_ARR[i];
            if (value >= unit.size) {
                return getSizeWithUnit(value, unitType, unit, showDecimal, showUnit);
            }
        }
    }
}
